import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { announcementId: Number }

  dismiss() {
    const csrfToken = document.querySelector('[name="csrf-token"]')?.content

    fetch('/announcement_dismissals', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken || ''
      },
      body: JSON.stringify({ announcement_id: this.announcementIdValue })
    }).catch(error => {
      console.warn('Failed to record announcement dismissal:', error)
    })
  }
}
